/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable, ErrorHandler } from '@angular/core';

import { sessionErrorTracking } from 'src/app/plain-javascript/services/SessionErrorTracking';
import { fbReporting } from 'src/app/plain-javascript/background-scripts/fb-reporting';

@Injectable()
export class AnotherErrorHandler extends ErrorHandler {
	constructor() {
		super();
	}
	public override handleError(error: any) {
		super.handleError(error);
		this.legacyErrorHandling(error);
	}

	//the old error handling code just pasted in as a temp fix
	public legacyErrorHandling(event: any) {
		let fakeError = 'An error occurred. Contact Support if you need product help.';
		let extra = {
			url: null as any,
			line: null as any,
			col: null as any,
			stack: null as any,
			code: null as any,
		};
		let errorMessage: string = event.message;
		if (event.filename) {
			extra.url = event.filename;
		}
		if (event.lineno) {
			extra.line = event.lineno;
		}
		if (event.colno) {
			extra.col = event.colno;
		}
		//apparently there's poor support?
		if (event.error) {
			let e = event.error;
			if (e.stack) {
				extra.stack = e.stack;
			}
			if (e.code) {
				extra.code = e.code;
			}
		}
		if ((event as any).extra) {
			Object.assign(extra, (event as any).extra);
		}

		//it's a fairly normal error
		if (event.stack) {
			extra.stack = event.stack;
		}

		//list of errors to be explictly ignored
		let errorSuppressionList = ['PERMISSION_DENIED: Permission denied'];
		//list of errors to be explictly ignored, it's also fuzzy
		let fuzzyUISuppressionList = ['SecurityError (DOM Exception 18)', 'permission_denied'];

		let ignoreError = false;
		let hideError = false;
		for (let i = 0; i < errorSuppressionList.length; i++) {
			if (errorSuppressionList[i] === errorMessage) {
				ignoreError = true;
			}
		}
		for (let i = 0; i < fuzzyUISuppressionList.length; i++) {
			// if(errorMsg.indexOf(fuzzyUISuppressionList[i]) !== -1){hideError = true;}
			if (errorMessage.toLowerCase().indexOf(fuzzyUISuppressionList[i].toLowerCase()) !== -1) {
				ignoreError = true;
			}
		}

		sessionErrorTracking.pushError(errorMessage);

		if (!ignoreError) {
			if (fbReporting) {
				fbReporting.reportError(errorMessage, extra);
			}
			if (!hideError) {
				Logging.error(fakeError);
			}
		}
		Logging.debug(errorMessage);
		return false;
	}
}
